import { getDriversAutocomplete } from "@/api/Rest/drivers/autocomplete";
import { useFieldContext } from "./form.context";
import { GenericAsyncAutocomplete } from "./genericAsyncAutocomplete";

type DriverAutocompleteOption = {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
};

export function DriverAutocomplete() {
  const field = useFieldContext<number | null>();
  const storedValue = field.state.value ?? null;
  const errors = field.state.meta.errors;
  const hasError = field.state.meta.isTouched && errors.length > 0;

  return (
    <GenericAsyncAutocomplete<DriverAutocompleteOption, number>
      queryKeyPrefix="drivers"
      queryFn={async (query) => getDriversAutocomplete(query, 10)}
      getOptionLabel={(d) => {
        const emailPart = d.email?.split("@")[0] ?? "";
        return `${d.id} - ${d.firstName} ${d.lastName} (${emailPart})`;
      }}
      getOptionValue={(d) => d.id}
      label="Envoyer à un driver"
      placeholder="Envoyer À Un Driver"
      value={storedValue}
      initialOptionLabel={storedValue ? String(storedValue) : undefined}
      onChange={(val) => field.handleChange(val)}
      onBlur={field.handleBlur}
      error={hasError}
      helperText={hasError ? errors[0]?.message : ""}
      noOptionsText={(query) =>
        query.length < 1 ? "Tapez pour rechercher un chauffeur" : "Aucun chauffeur trouvé"
      }
    />
  );
}
